import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
const TransBase = ({ title, description, appleTouchIcon, androidIcon512, androidIcon192, favicon32, faviconICO }) => {
  const publicUrl = process.env.PUBLIC_URL;
  return (
    <>
    <Helmet>
    <title>{title || 'TransBase Official Website'}</title>
    <meta name="description" content={description || 'TransBase • EnbyBase Official Website'} />
    <meta property="og:title" content={title || 'TransBase Official Website'}/>
    <meta property="og:description" content={description || 'TransBase • EnbyBase Official Website'}/>
    <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${publicUrl}/${appleTouchIcon || 'apple-touch-icon-tb.png'}`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="512x512"
        href={`${publicUrl}/${androidIcon512 || 'android-chrome-512x512-tb.png'}`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href={`${publicUrl}/${androidIcon192 || 'android-chrome-192x192-tb.png'}`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${publicUrl}/${favicon32 || 'favicon-32x32-tb.png'}`}
      />
      <link
        rel="icon"
        href={`${publicUrl}/${faviconICO || 'favicon-tb.ico'}`}
      />
  </Helmet>
    <div>
      <h1>This is the Transbase Page</h1>
    </div></>
  );
};

export default TransBase;
